import { Box } from '@chakra-ui/react';

import { tableHeadLists } from './const';
import { useApp } from '@pages/UploadMappingV2/context/AppContext';
import TableListProduct from '@pages/UploadMappingV2/components/Table/TableListProduct';
import useMutateUploadMapping from '@pages/UploadMappingV2/hooks/mutate/useMutateUploadMapping';
import { useFilterPSatuan } from '@pages/UploadMappingV2/hooks/state/useFilter';
import { usePaginationPSatuan } from '@pages/UploadMappingV2/hooks/state/useAllMappingPagination';
import ModalAddProductSatuan from '@pages/UploadMappingV2/components/ModalAddProductSatuan';
import { usePieceStore } from '@pages/UploadMappingV2/hooks/state/useAddProductSatuan';
import ModalConfirmAddProductSatuan from '@pages/UploadMappingV2/components/ModalConfirmAddProductSatuan';

export default function ProductSatuan({ data, isLoading }) {
    const tableData = data?.data?.page_data;
    const { editProductSatuan } = useMutateUploadMapping();
    const { isOpenModalConfirmAddProductPiece, onCloseModalConfirmAddProductPiece } = useApp();

    const { setSort } = useFilterPSatuan();
    const { directPieces, resetPieces } = usePieceStore();
    const { page, limit, setPage, setLimit } = usePaginationPSatuan();

    const handleConfirmSave = () => {
        const payload = directPieces.map(({ id, created_at, ...rest }) => ({
            ...rest,
        }))[0];

        editProductSatuan.mutate({ id: directPieces[0].id, payload: { piece: payload } });
    };

    const handleCancelSave = () => {
        onCloseModalConfirmAddProductPiece();
        resetPieces();
    };

    const onChangeSort = (sort) => setSort(sort);
    const onChangeLimit = (limit) => setLimit(limit);
    const onPageChange = (page) => setPage(page.selected + 1);

    return (
        <Box>
            <TableListProduct
                isCanAddItem={false}
                tableHeadLists={tableHeadLists}
                tableData={tableData}
                data={data?.data}
                isLoading={isLoading}
                isPagination={tableData?.length > 0}
                onChangeSort={onChangeSort}
                onChangeLimit={onChangeLimit}
                onPageChange={onPageChange}
                limit={limit}
                page={page}
            />

            <ModalAddProductSatuan />

            <ModalConfirmAddProductSatuan
                isOpen={isOpenModalConfirmAddProductPiece}
                onClose={handleCancelSave}
                onSubmit={handleConfirmSave}
            />
        </Box>
    );
}
